import * as React from 'react';

export const downloader = (url) => {
    const form = document.getElementById('form-download') as HTMLFormElement;
    form.action = url;
    form.submit();
};

export let Download: any = () => {
    return (
        <div>
            <form id='form-download' method='POST' target='iframe-download'></form>
            <iframe name= 'iframe-download' style= {{ display: 'none' }}></iframe>
        </div>
    );
};
